import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { throwError } from 'rxjs';
import { ApiService } from "../data/api.service";
import { AppSettingsModel } from "../../models/core/app-settings.model";

@Injectable()
export class AppSettingsService {
    hasError: boolean;
    //public baseUrl: any;
    public baseReportsUrl: any;
    public brandLogo: any;
    public brandLogoHeaderWidth: any;
    public companyLogo: any;
    public companyLogoHeader: any;
    public companyLogoHeaderWidth: any;
    public fixedScreen1: any;
    public fixedScreen1Title: any;
    public fixedScreen2: any;
    public fixedScreen2Title: any;
    public fixedScreen3: any;
    public fixedScreen3Title: any;
    public fixedScreen4: any;
    public fixedScreen4Title: any;
    public fixedScreen5: any;
    public fixedScreen5Title: any;
    public fixedScreen6: any;
    public fixedScreen6Title: any;

    constructor(private apiService: ApiService) {
        this.apiService.get<AppSettingsModel>(`api/AppSettings`).pipe(
            catchError(error => this.handleError(error))
        ).subscribe(response => {
            //this.baseUrl = response.baseUrl;
            this.baseReportsUrl = response.baseReportsUrl;
            this.brandLogo = response.brandLogo;
            this.brandLogoHeaderWidth = response.brandLogoHeaderWidth;
            this.companyLogo = response.companyLogo;
            this.companyLogoHeader = response.companyLogoHeader;
            this.companyLogoHeaderWidth = response.companyLogoHeaderWidth;
            this.fixedScreen1 = response.fixedScreen1;
            this.fixedScreen1Title = response.fixedScreen1Title;
            this.fixedScreen2 = response.fixedScreen2;
            this.fixedScreen2Title = response.fixedScreen2Title;
            this.fixedScreen3 = response.fixedScreen3;
            this.fixedScreen3Title = response.fixedScreen3Title;
            this.fixedScreen4 = response.fixedScreen4;
            this.fixedScreen4Title = response.fixedScreen4Title;
            this.fixedScreen5 = response.fixedScreen5;
            this.fixedScreen5Title = response.fixedScreen5Title;
            this.fixedScreen6 = response.fixedScreen6;
            this.fixedScreen6Title = response.fixedScreen6Title;
        });
    }
    private handleError(error: HttpErrorResponse) {
        this.hasError = true;
        return throwError(() => error);
    }
}
